import loadable from '@loadable/component';
import { useParams } from 'react-router-dom';
import Spinner from '../../components/Reusable/Spinner';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
import usePatchHook from '../../customHooks/usePatchHook';

const EditEmailCampaignComponent = loadable(
  () => import('../../components/EmailCampaign/EmailCampaignUpdate')
);
const EditEmailCampaign = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetHook({
    queryKey: ['email-campaign', `email-campaign-${id}`],
    url: `${APIS.EMAIL_CAMPAIGN}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isUpdating } = usePatchHook({
    queryKey: ['email-campaign'],
    navigateURL: '/email-sms-marketing/email-campaign',
  });

  const handleEdit = async (values: any, setError: any, isDraft: boolean) => {
    const url = `${APIS.EMAIL_CAMPAIGN}${id}/`;
    const formData = {
      ...values,
      is_draft: isDraft,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditEmailCampaignComponent
          data={data}
          handleEdit={handleEdit}
          isLoading={isUpdating}
        />
      )}
    </>
  );
};

export default EditEmailCampaign;
